import { type DocumentNode, type FieldNode, type OperationDefinitionNode } from 'graphql'

function getOperationDefinition(doc?: DocumentNode): OperationDefinitionNode | undefined {
  return doc?.definitions?.find((definition) => definition.kind === 'OperationDefinition') as
    | OperationDefinitionNode
    | undefined
}

function mergeOperationDefinitions(
  target: OperationDefinitionNode,
  source: OperationDefinitionNode
): OperationDefinitionNode {
  const targetSelection = target?.selectionSet?.selections[0] as FieldNode
  const sourceSelection = source?.selectionSet?.selections[0] as FieldNode
  return {
    kind: 'OperationDefinition',
    operation: target?.operation,
    name: target?.name,
    variableDefinitions: target?.variableDefinitions,
    directives: target?.directives,
    selectionSet: {
      kind: 'SelectionSet',
      selections: [
        {
          arguments: targetSelection?.arguments,
          directives: targetSelection?.directives,
          kind: 'Field',
          name: targetSelection?.name,
          selectionSet: {
            kind: 'SelectionSet',
            selections: [
              ...(targetSelection?.selectionSet?.selections ?? []),
              ...(sourceSelection?.selectionSet?.selections ?? []),
            ],
          },
        } as FieldNode,
      ],
    },
  } as OperationDefinitionNode
}

export default function mergeDocumentNode(documentOne: DocumentNode, documentTwo?: DocumentNode): DocumentNode {
  if (!documentOne || !documentTwo) {
    return documentOne
  }
  const operationDefinitionOne = getOperationDefinition(documentOne)
  const operationDefinitionTwo = getOperationDefinition(documentTwo)
  if (!operationDefinitionOne || !operationDefinitionTwo) {
    throw new Error('Cannot merge documents without operation definitions')
  }
  const newOperationDefinition = mergeOperationDefinitions(operationDefinitionOne, operationDefinitionTwo)

  const definitions = [
    newOperationDefinition,
    ...documentOne.definitions.filter((def) => def.kind !== 'OperationDefinition'),
    ...documentTwo.definitions.filter(
      (def) => def.kind !== 'OperationDefinition' && !documentOne.definitions.includes(def)
    ),
  ]

  return {
    kind: documentOne.kind,
    definitions,
  } as DocumentNode
}
